import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
var _pendingLogSent = /*#__PURE__*/_classPrivateFieldLooseKey("pendingLogSent");
var _getLogsFromStorage = /*#__PURE__*/_classPrivateFieldLooseKey("getLogsFromStorage");
export default class DirectStrategy {
  constructor(sender, storage, options) {
    Object.defineProperty(this, _getLogsFromStorage, {
      value: _getLogsFromStorage2
    });
    this.sender = void 0;
    this.storage = void 0;
    this.handledLogTypes = void 0;
    this.ignoredLogTypes = void 0;
    Object.defineProperty(this, _pendingLogSent, {
      writable: true,
      value: new Set()
    });
    this.sender = sender;
    this.storage = storage;
    this.handledLogTypes = options.handledLogTypes || null;
    this.ignoredLogTypes = options.ignoredLogTypes || null;
  }
  notify() {
    var _this = this;
    return _asyncToGenerator(function* () {
      const logsToBeSent = (yield _classPrivateFieldLooseBase(_this, _getLogsFromStorage)[_getLogsFromStorage]()).filter(log => !_classPrivateFieldLooseBase(_this, _pendingLogSent)[_pendingLogSent].has(log.uid));
      if (logsToBeSent.length === 0) {
        return;
      }
      logsToBeSent.map(e => _classPrivateFieldLooseBase(_this, _pendingLogSent)[_pendingLogSent].add(e.uid));
      yield _this.sender.send(logsToBeSent, _this.acknowledge.bind(_this));
    })();
  }
  acknowledge(handledLogKeys) {
    var _this2 = this;
    // Here, we are launching multiple async fonction in parallel, which is ok in this particular case since
    // we do not need to wait for the whole loop to finish, nor do we need each loop to wait for eachother
    // We only want to wait for the storage instruction to finish before marking the key as sent.
    handledLogKeys.forEach(/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* (key) {
        yield _this2.storage.delete(key);
        _classPrivateFieldLooseBase(_this2, _pendingLogSent)[_pendingLogSent].delete(key);
      });
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  }

  // for debug and test
  getPendingLogs() {
    return _classPrivateFieldLooseBase(this, _pendingLogSent)[_pendingLogSent];
  }
}
function _getLogsFromStorage2() {
  return _getLogsFromStorage3.apply(this, arguments);
}
function _getLogsFromStorage3() {
  _getLogsFromStorage3 = _asyncToGenerator(function* () {
    return this.ignoredLogTypes ? this.storage.getLogsNotOfType(Infinity, this.ignoredLogTypes) : this.storage.getLogsOfType(Infinity, this.handledLogTypes);
  });
  return _getLogsFromStorage3.apply(this, arguments);
}
//# sourceMappingURL=index.js.map